import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Sarah M.',
  location: 'Miami Lakes',
  text: "As a mother of three without dental insurance, the VIP Plan has been a lifesaver. We know exactly what we're paying each year, and the staff is incredibly welcoming to our kids."
}, {
  name: 'David R.',
  location: 'Hialeah',
  text: 'I used to avoid the dentist because I never knew what the bill would be. With the VIP Plan, my cleanings are covered and I get a discount on anything else I need. Highly recommend Lima Dental.'
}, {
  name: 'Elena G.',
  location: 'Doral',
  text: 'Premium care without the premium price tag. The office is beautiful, the team is professional, and the 20% discount on treatments has saved me hundreds already.'
}];
export function Testimonials() {
  return <section className="py-24 lg:py-32 bg-white" data-id="element-176">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
        <div className="text-center mb-20" data-id="element-178">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-3xl md:text-4xl lg:text-5xl font-light text-brand-dark mb-6 tracking-tight" data-id="element-179">
            Trusted by Families in Miami Lakes, Hialeah & Doral
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1,
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-lg text-brand-muted font-light" data-id="element-180">
            See why our community chooses Lima Dental Group for their family's
            care.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-181">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.8,
          ease: 'easeOut'
        }} className="bg-brand-dark p-10 rounded-3xl flex flex-col h-full" data-id="element-182">
              <div className="flex text-white/80 mb-8 space-x-1" data-id="element-183">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-184" />)}
              </div>
              <p className="text-white/90 mb-10 font-light leading-relaxed flex-grow text-lg" data-id="element-185">
                "{testimonial.text}"
              </p>
              <div data-id="element-186">
                <p className="font-medium text-white" data-id="element-187">{testimonial.name}</p>
                <p className="text-sm text-white/50 font-light mt-1" data-id="element-188">
                  {testimonial.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}